import MicroPythonBoard from './micropython';

function toHexString(byteArray) {
    return Array.from(byteArray, function (byte) {
        return ('0' + (byte & 0xFF).toString(16)).slice(-2);
    }).join('')
}

function sleep(millis) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve()
        }, millis)
    })
}

export default class CodeUploader {

    BOARD_OPTIONS = {
        baudRate: 115200,
    }

    constructor() {
        this.connected = false
        this.readyForUpload = true
        this.board = new MicroPythonBoard()

    }

    async createDirectory(path) {
        await this.board.fs_mkdir(path)
    }

    async upload(contents, path = "/main.py", progress_callback = null) {
        console.log("Uploading to " + path)
        await sleep(150)
        await this.board.stop()
        await sleep(150)
        await this.board.fs_save(contents, path, undefined, progress_callback)
        console.log("Finished uploading!")
        return "Finished"

    }
    async getFirmwareVersion() {
        return await this.board.getFirmwareVersion()
    }

    async reset() {
        await this.board.reset()
    }

    async getFileContent(path) {
        return await this.board.fs_cat(path)
    }

    async listFiles(path) {
        console.log(await this.board.fs_ls(path))
    }
    async connect() {
        console.log(await navigator.usb.getDevices())
        var port = await this.board.requestPort([{ 'usbVendorId': 0x2341, 'productId': 0x0070 }])
        // check if 
        if (port) {
            await this.board.open(port, this.BOARD_OPTIONS)
            this.connected = true
        } else {
            throw Error("Bitte wähle ein Board!")
        }
    }



    async disconnect() {
        if (this.board) {
            await this.dfuDevice.close();
            this.board = undefined;
        } else {
            console.warn("Attempted to close a non-exsistent Serial port.")
        }
    }

    isSupported() {
        return (navigator.serial !== undefined)
    }
}